/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import { useSelector, useDispatch } from "react-redux";
import {
  responseTimekeeping,
  responseMiddleware,
} from "../../../redux/reducers";
import {
  showTimekeepingOnlineData,
  IsPermisionOidRequired,
} from "../../../redux/actions";
import "./style.scss";
import TimekeepingOnlineDataTableList from "./TimekeepingOnlineDataTable";
import UsingIntl from "../../../services/using_intl";

export default function TimekeepingOnlineDataList() {
  let dataGrid = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { timekeepingOnlineData } = useSelector(responseTimekeeping);
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    dispatch(IsPermisionOidRequired());
    UsingIntl();
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
      dispatch(showTimekeepingOnlineData());
    }
  }, [middleware]);

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("TimekeepingOnlineData")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/timekeeping-online/list" className={"breadcrumb-item"}>
            {formatMessage("Timekeeping")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("TimekeepingOnlineData")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          
          <TimekeepingOnlineDataTableList
            dataTable={timekeepingOnlineData}
            middleware={middleware}
            dataGrid={dataGrid}
          />
        </div>
      </div>
    </div>
  );
}
